import {Document} from '../models/document.modal';

export class DocHelper {
  static getDocumentSection(docDetails: Document[], sectionName = ''): any[] {
    if  (!docDetails?.length) {
      return [];
    }
    return docDetails?.filter(doc => doc?.section_name?.toLowerCase() === sectionName.toLowerCase());
  }
}
